import React, {useEffect, useState} from 'react';

// custom components
import { Text } from '../../atoms';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

// utils
import { Colors } from '../../../styles';

const RequestFields = (props) => {

    useEffect(() => {

    }, []);

    const [STATE, SETSTATE] = useState(false)

    const Row = (row) => {
        return (
            <tr>
                <td scope="col"><Text.TableHeader bold={true}>{row.parameter}</Text.TableHeader></td>
                <td scope="col"><Text.TableBody>{row.description}</Text.TableBody></td>
                <td scope="col"><Text.TableBody>{row.example}</Text.TableBody></td>
                <td scope="col"><Text.TableBody>{row.optional}</Text.TableBody></td>
            </tr>
        )
    }

    return (
        <div>
            <table class="table" style={{ }}>
                <thead style={{}}>
                    <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                        <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Parameter</th>
                        <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Description</th>
                        <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Example</th>
                        <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Optional</th>
                    </tr>
                </thead>
                <tbody>
                    { props.rows.map((row) => 
                        <Row parameter={row['parameter']} description={row['description']} example={row['example']} optional={row['optional']} />
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default RequestFields;
